import { createIntl, createIntlCache } from 'react-intl';

import { DEFAULT_LOCALE, i18nMessagesEmbedded } from 'src/util/i18n/handler';

// Prevents memory leak per recommendation by react-intl.
const cache = createIntlCache();

let intl = createIntl(
  {
    locale: DEFAULT_LOCALE,
    messages: i18nMessagesEmbedded(DEFAULT_LOCALE),
  },
  cache,
);

/**
 * Initializes configured partner currency formatting before the first render.
 * @param {{locale: string, messages: object}} config loaded partner i18n configuration.
 * @returns {object} initialized React Intl shape.
 */
export const initializeIntlCurrency = ({ locale, messages }) => {
  intl = createIntl({ locale, messages }, cache);
  return intl;
};

/**
 * Returns the configured partner currency symbol from its currency formatter.
 * @param {import('react-intl').IntlShape} intlCurrency - Partner currency formatter.
 * @returns {string|null} Partner currency symbol, or null when no formatter is available.
 */
export const getCurrencySymbol = (intlCurrency) => {
  if (!intlCurrency) {
    return null;
  }

  return intlCurrency.formatMessage({
    id: 'common.entities.currency.label',
    defaultMessage: '$',
  });
};

export const useIntlCurrency = () => intl;
